export const SENTRY_ANALYTIC = 'ANALYTIC';

export const SENTRY_AXIOS = 'APP_AXIOS';

export const SENTRY_CABINET = 'CABINET';
